import { isDemoShop } from '@/lib/is-demo-shop'
import type { Shop } from '@/lib/api/shops'

export const SUPPORT_TELEGRAM_URL = 'https://t.me/rnpWB'

export function hasShopDataAccess(
  shop: Shop | null | undefined,
  options: { isAdmin?: boolean } = {},
): boolean {
  if (!shop) return false
  if (options.isAdmin || isDemoShop(shop)) return true

  if (shop.trial_used === false) return true

  return shop.subscription?.status === 'active'
}
